module.exports = __webpack_public_path__ + "img/Logo_Navbar_Health_Rider_2.231b6f08.png";